import { useMutation } from '@tanstack/react-query';
import { CLIENT_ID_QUERY_KEY } from '@/consts/const';
import { useFetch } from '@/hooks/useFetch';
import { useSearchQuery } from '@/hooks/useSearchQuery';
import type { PostCreateAirRequestResponse } from '@/types/airRequestApiTypes';

interface UseCreateAirRequestMutationProps {
  clientIdParam?: number | string | null;
}

interface CreateAirRequestMutationPayload {
  clientId?: number | string | null;
}

export const useCreateAirRequestMutation = ({ clientIdParam }: UseCreateAirRequestMutationProps = {}) => {
  const [searchQuery] = useSearchQuery();
  const clientId = clientIdParam ?? searchQuery.get(CLIENT_ID_QUERY_KEY);
  const { doFetch: createAirRequest } = useFetch<object, PostCreateAirRequestResponse>();

  return useMutation({
    mutationFn: (payload?: CreateAirRequestMutationPayload) =>
      createAirRequest(`/api/clients/${payload?.clientId ?? clientId}/air-requests`, {
        method: 'POST',
        body: {},
      }),
  });
};